import { GridSkeleton, TextSkeleton } from "@/components/Skeletons";

export default function BalanceSheetSkeleton() {
  return (
    <div className="pb-16">
      <div className="flex gap-4">
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={10} />
          <GridSkeleton columns={1} rows={4} />
        </div>
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={10} />
          <GridSkeleton columns={1} rows={4} />
        </div>
      </div>
      <div className="py-4" />
      <div className="py-4" />
      <div className="flex gap-4">
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={10} />
          <GridSkeleton columns={1} rows={4} />
        </div>
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={10} />
          <GridSkeleton columns={1} rows={4} />
        </div>
      </div>
      <div className="py-4" />
      <div className="py-4" />
      <div className="flex w-1/2 gap-4">
        <div className="flex flex-1 flex-col gap-4">
          <TextSkeleton width={10} />
          <GridSkeleton columns={1} rows={6} />
        </div>
      </div>
    </div>
  );
}
